import * as React from 'react';
import {isEmpty} from "../utilities/Utilities";
import {useLocation} from "react-router-dom";

// export class OrlenPaczka extends React.Component<Props, State> {
const InpostPaczka = () => {
    const location = useLocation();

    // Parsowanie query string
    const queryParams = new URLSearchParams(location.search);
    const kod = queryParams.get('kod') || '';

    // console.log(kod);

    return (
        <iframe title={'Mapa punktów InPost'} src={`paczkaInpost.html?kod=${kod}` } style={{width: '100%', height: 'calc(100vh - 6px)'}}></iframe>
        // <iframe src={`paczkaOrlen.html?kod=${params.kod}` } style={{width: '100%', height: '100vh'}}></iframe>
    );

}


export default InpostPaczka

